import { FunctionComponent } from 'react';
import styles from "./Pagination.module.css";
import cn from 'classnames';
import FilterSelect, { ThemePlacement, ThemeType } from '../../common/FilterSelect/FilterSelect';

export interface Option {
  value: string;
  label: string;
}


interface IPaginationProps {
    enteriesShows: string;
    pageNumbers: React.ReactNode | React.ReactElement;
    dropDownOptions: Option[];
    dropdownOnChange: (value: string) => void;
    dropDownPlaceholder: string;
    className?: string;
};

const Pagination: FunctionComponent<IPaginationProps> = ({className, pageNumbers, dropDownOptions, dropdownOnChange, dropDownPlaceholder, enteriesShows }) => {
    
    return (
        <div className={cn(styles.paginationWrapp, className)}>
            <div className={styles.totalPageCount}>
                {enteriesShows}
            </div>
            <div className={styles.pageNumbers}>
                {pageNumbers}
            </div>
            <div className={styles.pageCount}>
                <FilterSelect
                    options={dropDownOptions}
                    onSelect={dropdownOnChange}
                    placeholder={dropDownPlaceholder}
                    dropdownTheme={ThemeType.LIGHT}
                    placement={ThemePlacement.TOP}
                />
                <span className={styles.pageCountTItle}>Entries Per Page</span>
            </div>
        </div>
    );
};

export default Pagination;
